module.exports = __webpack_public_path__ + "img/SMFLogo.986a53ea.png";